module.exports = __webpack_public_path__ + "img/948853b.jpg";